import { render, staticRenderFns } from "./mermaidBind.vue?vue&type=template&id=681b06f9&scoped=true&"
import script from "./mermaidBind.vue?vue&type=script&lang=js&"
export * from "./mermaidBind.vue?vue&type=script&lang=js&"
import style0 from "./mermaidBind.vue?vue&type=style&index=0&id=681b06f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b06f9",
  null
  
)

export default component.exports